<template>
	<div class="tabs" :style="'font-size:'+fontSize+';color:'+color">
		<div class="top_">
			<div class="tab" v-for="item,index in tabsList" :key="index"
			:style="'margin-right:'+padding" @click="tabClick(index,$event)">
				{{item}}
			</div>
		</div>
		<div class="bottom">
			<div :style="'width:'+tabsList[tabIndex].length*fontWidth+'px;'+
			'left:calc('+leftFontNum*fontWidth+'px + '+tabIndex+'*'+padding+');'"
			></div>
		</div>
	</div>
</template>

<script>
export default {
	name:"myTabs",
	data() {
		return {
			
			tabIndex:0,
			leftFontNum:0,
			fontWidth:0,	//字体宽度
			tabsNode:[],
		};
	},
	props:{
		
		offsetTopList:{		//下方内容模块距离页面顶部距离
			type:Array,
			default(){
				return []
			}
		},
		tabsList:{			//标签栏内容
			type:Array,
			default(){
				return []
			},
			required:true
		},
		fontSize:{			//字体尺寸
			type:String,
			default:"16px"
		},
		padding:{			//标签间距
			type:String,
			default:"12px"
		},
		color:{				//字体颜色
			type:String,
			default:"#212F46"
		}
	},
	mounted() {
		// 计算字体大小
		if(this.tabsList){
			this.tabsNode=document.getElementsByClassName('tab')
			console.log(this.tabsNode);
			this.fontWidth=document.getElementsByClassName('tab')[0].clientWidth/this.tabsList[0].length;
			console.log(this.fontWidth);
		}
	},
	methods:{
		tabClick(index){
			if(index!==this.tabIndex){
				this.tabIndex=index;
				let fontNum=0;
				for(let i=0;i<index;i++){
					fontNum+=this.tabsList[i].length
				}
				this.leftFontNum=fontNum;
			}
			console.log(index);
			if(index===0){
				window.scrollTo(0,0)
				this.$bus.$emit('pageChange',0)
				
			}else if(index===1){
				// window.location.href="#job"
				// window.scrollTo(0,this.offsetTopList[4]-160)
				window.location.href='#page5'
				this.$bus.$emit('pageChange',4)
			}else if(index===2){
				window.location.href="#page6"
				// document.documentElement.scrollTop=this.offsetTopList[5]
				this.$bus.$emit('pageChange',5)
			}
		},
		tabIndexChange(index){
			this.tabIndex=index;
			let fontNum=0;
			for(let i=0;i<index;i++){
				fontNum+=this.tabsList[i].length
			}
			this.leftFontNum=fontNum;
		}
	}
}
</script>

<style scoped lang="scss">
	.tabs{
		
		
		font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		font-weight: 500;
		
		.top_{
			display: flex;
			.tab{
				cursor: pointer;
				&:nth-last-of-type(1){
					margin-right: 0 !important;
				}
			}
		}
		
		.bottom{
			height: 0.2vw;
			position: relative;
			>div{
				position: absolute;
				height: 100%;
				background-color: #212F46;
				transition: 0.2s;
			}
		}
	}
</style>